/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Glucose from './glucose';
import GlucoseDetail from './glucose-detail';
import GlucoseUpdate from './glucose-update';
import GlucoseDeleteDialog from './glucose-delete-dialog';

const GlucoseRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Glucose />} />
    <Route path="new" element={<GlucoseUpdate />} />
    <Route path=":id">
      <Route index element={<GlucoseDetail />} />
      <Route path="edit" element={<GlucoseUpdate />} />
      <Route path="delete" element={<GlucoseDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GlucoseRoutes;
